/**
 * @fileoverview GET handler for the "/engagement/canvas_comparison_reports/canvases(/:app_group_id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasComparisonReportsCanvasesAppGroupId } from "./constants";
import type {
  EngagementCanvasComparisonReportsCanvasesAppGroupIdResult,
  EngagementCanvasComparisonReportsCanvasesAppGroupIdParams,
} from "./types";

export const getEngagementCanvasComparisonReportsCanvasesAppGroupId = reactQueryFetcherAdapter(
  engagementCanvasComparisonReportsCanvasesAppGroupId,
  (
    signal: AbortSignal,
    params: EngagementCanvasComparisonReportsCanvasesAppGroupIdParams
  ): Promise<EngagementCanvasComparisonReportsCanvasesAppGroupIdResult> => {
    const { app_group_id, ...restParams } = params;
    return fetch(
      `/engagement/canvas_comparison_reports/canvases${app_group_id ? `/${app_group_id}` : ""}`,
      "GET",
      restParams,
      { signal }
    );
  }
);
